import React from 'react';
import { Link } from 'react-router-dom';

const PrimaryButton = ({ children, to, href, className = '', ...props }) => {
  if (to) {
    return (
      <Link to={to} className={`button button-primary ${className}`.trim()} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a href={href} className={`button button-primary ${className}`.trim()} {...props}>
      {children}
    </a>
  );
};

export default PrimaryButton;
